<template>
	<div class="c-body">
		<div class="c-body__title">
			<h2>
				<span>AsciiTree</span>
				<button @click="toggleHelp" :class="{'-active': showHelp}">
					<c-icon :name="'question-circle'"></c-icon>
				</button>
			</h2>
		</div>
		<div class="c-help">
			<div class="c-help__inner">
				<div class="e-section">
					<p>
						インデントで表現された階層から、ツリー文字列を出力します。<br>
						ドキュメント類への貼付けにどうぞ。
					</p>
				</div>
			</div>
		</div>
		<div class="c-body__inner">
			<div class="e-section">
				<div class="c-asciitree-app">
					<div class="e-grid -double">
						<div class="col">
							<div class="c-asciitree-app__title">
								<h3>INPUT</h3>
							</div>
							<div class="c-asciitree-app__editor" id="asciitree-editor"></div>
						</div>

						<div class="col">
							<div class="c-asciitree-app__title">
								<h3>OUTPUT</h3>
								<button class="e-button" @click="copy">クリップボードにコピー</button>
							</div>
							<div class="c-asciitree-app__editor" id="asciitree-output"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import mCommon from "../mixins/common";

import ace from "brace";
import AsciiTree from "../lib/asciitree";

export default {
	mixins: [
		mCommon
	],
	components: {
	},
	data (){
		return {
			defaultValue: "html\n\tassets\n\t\tjs\n\t\t\tmain.js\n\t\t\tvendor.js\n\t\tcss\n\t\t\tstyle.css\n\t\timg\n\t\t\tlogo.png\n\tindex.html",
			editor: null,
			output: null,
			editorOptions: {
				fontSize: 13
			}
		}
	},
	mounted (){
		// output editor:
		var output = this.output = ace.edit("asciitree-output");
		_.each(this.editorOptions, (value, key) => {
			output.setOption(key, value);
		});
		output.setOption("readOnly", true);
		output.setValue("output");

		// input editor:
		var editor = this.editor = ace.edit("asciitree-editor");
		_.each(this.editorOptions, (value, key) => {
			editor.setOption(key, value);
		});
		editor.getSession().setUseSoftTabs(false);
		editor.on("change", this.onChange);
		editor.setValue(this.defaultValue);
		editor.selection.clearSelection();
	},

	methods: {
		onChange (){
			var result = AsciiTree.parse(this.editor.getValue());
			this.output.setValue(result);
			this.output.selection.clearSelection();
		},
		copy (){
			if($.clipboard(this.output.getValue())){
				alert("クリップボードにコピーしました");
			} else {
				alert("クリップボードへのコピーに失敗しました");
			}
		}
	}
}
	
</script>


// WEBPACK FOOTER //
// asciitree.vue?7a329ce8